import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Margins = Record<string, Margin> | null;

export interface Margin {
  isolatedMarginAvailable: string;
  isolatedMarginBonusAvailable?: string;
  unrealizedPnl: string;
  usdtReservedForIsolatedMargin: string;
  reservedForIsolatedMargin: string;
  reservedForIsolatedMarginPosition: string;
  bonusCollateral: string;
  nonBonusCollateral: string;

  marginBalance: string;
  initMarginReserved: string;
  initPositionMargin: string;
  /** Aggregate maintenance position margin per quote currency. Optional during the additive backend rollout — treat absence as missing data and render `—`. */
  maintPositionMargin?: string;
  crossMarginAvailable: string;
  crossMarginRatio?: string;
}

export const marginsAtom = atom<Margins>(null);

export const subscribeMarginsBunja = createTableAccumulatorBunja(
  'private/margins',
  (store) => (wsData) => store.set(marginsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
subscribeMarginsBunja.debugLabel = 'subscribeMarginsBunja';
